"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSENT_TEXT_INPUT_TYPES = void 0;
/** Every type the signing host can post a text answer under; the publish rules and the compiler both hold fields to it. */
exports.CONSENT_TEXT_INPUT_TYPES = ['ec__text', 'ec__numeric', 'ec__email'];
//# sourceMappingURL=types.js.map